<template>
    <v-select
           fillled
            v-model="model"
            :items="data"
            item-text="name"
            item-value="id"
            :label="label || 'Seleccionar tipo' + (isMultiple ? 's' : '')"
            prepend-inner-icon="work"
            @click:clear="clear"
            return-object
            :disabled="loading || disabled"
            :required="isRequired"
    > </v-select>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {filterSelectorWithHeaders, filterUniqueIds} from '@/utils/Common'
    import {mapMutations} from 'vuex'

    export default{
        props: ['default', 'multiple', 'required' ,'types', 'serviceProviderId', 'label', 'disabled', 'value', 'includeIndividualAccountType'],
        data(){
            return {
                model: null,
                data: [],
                loading: false
            }
        },
        watch: {
            model(val){
                this.$emit('change', val)
            },
            value(val){
                if(val){
                    this.model = val
                }
            }
        },
        mounted(){
            this.model = this.data.length ? this.data[0] : null
            if (this.types == undefined) {
                this.getTypes()
                return
            }

            this.$emit('loaded')
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            filter: filterSelectorWithHeaders,
            clear(){
                this.model = []
            },
            async getTypes(){

                var vm = this
                var url = 'public/institution/types'

                vm.loading = true
                var response = await ApiUtils.makeGet(url)
                vm.loading = false

                if (!response.ok) {
                    vm.showSnackBar('Ha ocurrido un error consultando tipos de institucion')
                    return
                }

                var json = await response.json()
                if(vm.includeIndividualAccountType === true){
                    json.result.types.unshift({
                        id: 'individual',
                        name: 'Consulta Particular'
                    })
                }

                vm.model = {
                    id: 'individual',
                    name: 'Consulta Particular'
                }

                vm.$emit('loaded')

                vm.data = json.result.types

                vm.$nextTick(function(){
                    if(vm.value){
                        vm.model = vm.value
                    }
                })

            }
        },
        computed: {

            isMultiple(){
                return this.multiple != undefined && this.multiple !== false
            },

            isRequired(){
              return this.required != undefined && this.required !== false
            }
        }
    }
</script>
